import { Component, Input } from '@angular/core';
import { ControlBase } from '../../base/control-base/control-base.component';
import { NgxSpinnerService } from 'ngx-spinner';
import { ControlContainer, FormGroupDirective } from '@angular/forms';

@Component({
    selector: 'number-extended-control',
    templateUrl: 'number-extended.control.html',
    standalone: false,
    viewProviders: [{ provide: ControlContainer, useExisting: FormGroupDirective }],
})
export class NumberExtendedControl extends ControlBase {
    constructor(protected override spinnerService: NgxSpinnerService) {
        super(spinnerService);
    }

    @Input() controlName!: string;
    @Input() showIcon: boolean = true;
    @Input() iconClass: string = 'fas fa-align-justify';
    @Input() labelText!: string;
    @Input() placeholderText: string = '';
    @Input() inputClass: string = 'input';
    @Input() readonly: boolean = false;
    @Input() inputId: string = '';

    @Input() parentFormHelper!: {
        showFieldError(controlName: string): boolean;
        getErrorMessageHtml(controlName: string): string;
    };
}
